import React from 'react'
import withRedux from 'next-redux-wrapper'
import Theme from 'components/Theme'
import parse from 'lib/url/parse'
import { Actions as PageActions } from 'actions/page'
import { App, Store } from 'apps/public/profile/artistProfile'
import { storeSetup } from 'lib/pageSetup'
import { Actions as AlgoliaActions } from 'actions/algolia2/data'
import { parseUrlFacets, selectedFacetsToAlgoliaQueryString } from 'lib/algolia/v2'
import {
  getArtistDataLayer,
  getCuratorDataLayer,
  getProfileMetaData,
  getAllArtworksMetaData,
  getAllArtworksDataLayer,
  getUserName,
} from 'apps/public/profile/artistProfile/selectors'
import { CURATOR } from 'lib/user/constants'
import { getSlugifyDictionary, getAlgoliaSearchIndice } from 'selectors/algolia2/data'
import { getMeasurementUnit } from 'selectors/user/session'
import { getPageParams } from 'selectors/page'
import { algoliaArtworksApi } from 'apis/algolia'
import { getUserPreferencesDestinationZone } from 'selectors/user/cookie'
import {
  getPageParamsQuery,
  getAlgoliaQueryParams,
} from 'apps/public/profile/artistProfile/helpers'
const { ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_API } = process.env

export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
function Page() {
  return (
    <Theme>
      <App />
    </Theme>
  )
}

Page.clientSideTransitions = async ({ store, query }) => {
  if (window) {
    store.dispatch(PageActions.IS_READY(false))
    const { href } = window.location
    const pageParams = getPageParamsQuery(href)
    const { hitsPerPage, page } = pageParams
    const { section } = query
    // Redux Data
    const state = { ...store.getState() }
    const slugifyDictionary = getSlugifyDictionary(state)
    const pageParamsRedux = getPageParams(state)
    const { userId } = pageParamsRedux
    const searchIndice = getAlgoliaSearchIndice(state)
    const selectedFacets = parseUrlFacets({
      dictionary: slugifyDictionary,
      href: href,
    })
    const destinationZone = getUserPreferencesDestinationZone(state)
    // TODO - Geo Based
    const filters = selectedFacetsToAlgoliaQueryString(
      {
        ...selectedFacets,
      },
      { measurementUnit: getMeasurementUnit({ ...store.value }), destinationZone }
    )
    const algoliaParamsData = {
      applicationId,
      searchApi,
      searchIndice,
      filters,
      hitsPerPage: hitsPerPage || 100,
      ...(page ? { page } : {}),
      query: `"${userId}"`,
      restrictSearchableAttributes: 'id_user',
      typoTolerance: false,

      destinationZone,
    }
    const algoliaResults = await algoliaArtworksApi(algoliaParamsData)
    //     // Pull Query Variables ()
    const algoliaParams = getAlgoliaQueryParams(href)
    // Dispatch Array<ACTIONS>
    store.dispatch([
      PageActions.SET_PARAMS(algoliaParams),
      AlgoliaActions.SET_SELECTED_FACETS({ ...selectedFacets }),
      AlgoliaActions.UPDATE({
        data: algoliaResults,
      }),
      PageActions.SET({
        path: parse(href).path || '',
        params: {
          ...pageParams,
          ...algoliaParams,
          userId,
          section: section ? section : 'artworks',
        },
      }),
      PageActions.IS_READY(true),
    ])
    // Data Layer
    const dataLayer =
      section === 'artworks'
        ? getAllArtworksDataLayer({ ...store.getState() })
        : getArtistDataLayer({ ...store.getState() })
    window.dataLayer.push({ ...dataLayer, event: 'pageview' })
  }
}

Page.getInitialProps = async ({ req, store, res, query }) => {
  // Client-Side
  if (!req) {
    await Page.clientSideTransitions({
      store,
      query,
    })
    const { section } = query
    const state = { ...store.getState() }
    const metaData =
      section === 'artworks' ? getAllArtworksMetaData(state) : getProfileMetaData(state)
    return {
      metaData,
    }
  }

  // SSR
  storeSetup(store, req)
  const { originalUrl, accountData, accountType, algoliaSetUp } = req
  const { params } = req
  const { section } = params
  const pageData = {
    data: {
      accountData,
      accountType,
    },
    name: '/public/profile/artistProfile',
    params: { ...query },
    path: originalUrl,
  }
  store.dispatch(AlgoliaActions.INITIAL_SETUP(algoliaSetUp))
  // Page Data Setup
  store.dispatch(PageActions.SET(pageData))

  // Akamai Cache Tag
  const { userId } = query
  accountType === CURATOR
    ? res.set(
        'Edge-Cache-Tag',
        `page-curatorProfile, userId-${userId}, page-curatorProfile-${userId}`
      )
    : res.set('Edge-Cache-Tag', `page-userProfile, userId-${userId}, page-userProfile-${userId}`)
  // Metadata & Datalayer
  const state = { ...store.getState() }
  const metaData =
    section === 'artworks' ? getAllArtworksMetaData(state) : getProfileMetaData(state)
  const dataLayer =
    section === 'artworks'
      ? getAllArtworksDataLayer(state)
      : accountType === CURATOR
      ? getCuratorDataLayer(state)
      : getArtistDataLayer(state)
  return {
    dataLayer,
    metaData,
  }
}

export default withRedux(Store)(Page)
